import React from 'react';
import AnnexeEnfantUniquePageShell from '../../components/AnnexeEnfantUniquePageShell';
import EnfantUniqueStatic from './EnfantUniqueStatic';

export default function EnfantUnique() {
  return (
    <AnnexeEnfantUniquePageShell
      strapiApiId="annexe-enfant-unique"
      defaultSectionLabel="Annexes"
      defaultTitle="Enfant Unique"
      defaultTableSectionTitle="Explication pour remplir le formulaire"
      StaticFallback={EnfantUniqueStatic}
    />
  );
}
